import { isMobileOnly } from 'react-device-detect';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: ${isMobileOnly ? '90vw' : '1000px'};
  background: transparent;
  margin: 0px auto;
  padding: ${isMobileOnly ? '0' : '30px'}; ;
`;
